import { onAuthStateChanged } from 'firebase/auth';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';
import { getCurrentUser } from 'vuefire';
import { auth } from './firebase';

// Route components

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guards
router.beforeEach(async (to) => {
  // Check if route requires authentication
  if (!to.meta.isPublic) {
    const currentUser = await getCurrentUser();

    // If user is not logged in, redirect to login
    if (!currentUser) {
      return {
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      };
    }
  }

  // If user is logged in and tries to access login/register pages
  if (to.path === '/login' || to.path === '/register') {
    const currentUser = await getCurrentUser();
    if (currentUser) {
      return {
        path: '/',
      };
    }
  }

  // If user is logged in and tries to access admin pages in deployed environments
  if (to.path.startsWith('/admin') && !import.meta.env.DEV) {
    return {
      path: '/',
    };
  }

  // Handle 404
  if (to.matched.length === 0) {
    return {
      path: '/',
    };
  }
});

// Handle auth state changes
onAuthStateChanged(auth, (user) => {
  if (!user && window.location.pathname !== '/login') {
    router.push('/login');
  }
  else if (user && ['/login', '/register'].includes(window.location.pathname)) {
    router.push('/');
  }
});
